<template>
  <h1>{{ title }}</h1>
</template>

<script>
export default {
  name: "HeaderWithIcon",
  props: ["title"],
  setup() {},
};
</script>

<style lang="scss" scoped>
h1 {
  align-items: center;
  display: flex;
  font-size: 32px;
  justify-content: space-between;
  line-height: 36px;
}
</style>
